import vendorlandingRoutes from "./Vendorlanding";

const vendorlandingRoutesMap = {
  ...vendorlandingRoutes,
};

export default vendorlandingRoutesMap;
